/*
 * The texts of the calendar extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		calendar: {
			feed: 'Kalender abonnieren',
			subscribe: 'Abonnieren',
		},
	},
	components: {
		// efCalendar
		calendar: {
			today: 'Heute',
			previous: 'Zurück',
			next: 'Weiter',
			empty: 'Keine Einträge in diesem Zeitraum.',
			toggle_type: 'Ein- oder ausblenden',
			week: 'KW {week}',
			quarter: 'Q{quarter}',
			earlier_show: 'Einen früheren Eintrag anzeigen | {count} frühere Einträge anzeigen',
			earlier_hide: 'Frühere Einträge ausblenden',
			earlier_months_show: 'Einen früheren Monat anzeigen | {count} frühere Monate anzeigen',
			earlier_months_hide: 'Frühere Monate ausblenden',
			views: {
				month: 'Monat',
				year: 'Jahr',
				list: 'Liste',
			},
		},
	},
	modals: {
		me: {
			calendar_feed: {
				title: 'Kalender abonnieren',
				text: 'Deine Termine automatisch im eigenen Kalender. Er bleibt von selbst aktuell.',
				apple: 'Apple Kalender',
				apple_hint: 'Mac, iPhone und iPad',
				desktop: 'Outlook',
				desktop_hint: 'Desktop-App unter Windows',
				app: 'Kalender-App',
				app_hint: 'Auf diesem Gerät öffnen',
				google: 'Google Kalender',
				google_hint: 'Auch für Android',
				outlook: 'Outlook.com',
				outlook_hint: 'Privates Microsoft-Konto',
				ms365: 'Microsoft 365',
				ms365_hint: 'Arbeits- oder Schulkonto',
				scan: 'Auf dem Handy scannen',
				manual: 'Andere Kalender: Adresse manuell eintragen',
				url: 'Adresse des Abos',
				copy: 'In die Zwischenablage kopieren',
				copied: 'Adresse kopiert',
				other_hint: 'Zum Beispiel GMX, Web.de, Proton oder Nextcloud: die Adresse dort als Kalenderabo eintragen. Unter Android geht es über Google Kalender oder die App ICSx5.',
				secret: 'Die Adresse ist wie ein Passwort: Wer sie hat, sieht die Termine. Nicht weitergeben.',
				last_used: 'Zuletzt abgerufen: {date}',
				never_used: 'Noch nie abgerufen',
				regenerate: 'Neue Adresse erzeugen',
				unavailable: 'Für diese Anwendung ist kein Kalenderabo eingerichtet.',
			},
		},
	},
	confirms: {
		regenerate_calendar_token: {
			title: 'Neue Adresse erzeugen',
			text: 'Die bisherige Adresse wird ungueltig. Jedes Kalenderprogramm, das sie eingetragen hat, muss neu eingerichtet werden. Fortfahren?',
		},
	},
};
